var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-row-data text-right"},[_c('span',{staticClass:"mx-2 card-grid-display font-weight-regular"},[_vm._v(_vm._s(_vm.getCell))])])}
var staticRenderFns = []

export { render, staticRenderFns }